/** Curated sample images for GemBook UI (local gems + Unsplash avatars + Mixkit video) */

export const LOCAL_GEMS = {
  blueSapphire: '/assets/images/blue_sapphire_gemstone_1781700990385.jpg',
  redRuby: '/assets/images/red_ruby_gemstone_1781701006995.jpg',
  greenEmerald: '/assets/images/green_emerald_gemstone_1781701027567.jpg',
  padparadscha: '/assets/images/padparadscha_sapphire_1781701049583.jpg',
  collection: '/assets/images/gemstone_collection_luxury_1781701065808.jpg',
  blueSapphireAlt: '/assets/images/blue_sapphire_gem_1781700985688.jpg',
  emerald: '/assets/images/emerald_gemstone_1781701044795.jpg',
  pinkSpinel: '/assets/images/pink_spinel_gem_1781701058612.jpg',
  ruby: '/assets/images/ruby_gemstone_1781701002346.jpg',
  yellowSapphire: '/assets/images/yellow_sapphire_gem_1781701016187.jpg',
};

export const SAMPLE_AVATARS = [
  'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=256&h=256&fit=facearea&facepad=2&auto=format&q=80',
  'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=256&h=256&fit=facearea&facepad=2&auto=format&q=80',
  'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=256&h=256&fit=facearea&facepad=2&auto=format&q=80',
  'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=256&h=256&fit=facearea&facepad=2&auto=format&q=80',
  'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=256&h=256&fit=facearea&facepad=2&auto=format&q=80',
  'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=256&h=256&fit=facearea&facepad=2&auto=format&q=80',
  'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=256&h=256&fit=facearea&facepad=2&auto=format&q=80',
  'https://images.unsplash.com/photo-1527980965255-d3b416303d12?w=256&h=256&fit=facearea&facepad=2&auto=format&q=80',
];

/** Local gem photos — used for marketplace cards, listings, posts (always load) */
export const SAMPLE_GEMS = [
  LOCAL_GEMS.blueSapphire,
  LOCAL_GEMS.redRuby,
  LOCAL_GEMS.greenEmerald,
  LOCAL_GEMS.padparadscha,
  LOCAL_GEMS.collection,
  LOCAL_GEMS.pinkSpinel,
  LOCAL_GEMS.yellowSapphire,
  LOCAL_GEMS.emerald,
  LOCAL_GEMS.ruby,
  LOCAL_GEMS.blueSapphireAlt,
];

export const SAMPLE_COVERS = [
  LOCAL_GEMS.collection,
  LOCAL_GEMS.blueSapphire,
  LOCAL_GEMS.padparadscha,
  LOCAL_GEMS.redRuby,
  LOCAL_GEMS.greenEmerald,
];

export const SAMPLE_HERO = {
  gemOfTheDay: LOCAL_GEMS.yellowSapphire,
  blueSapphire: LOCAL_GEMS.blueSapphire,
  padparadscha: LOCAL_GEMS.padparadscha,
  collection: LOCAL_GEMS.collection,
  industryNews: LOCAL_GEMS.emerald,
};

export const SAMPLE_VIDEOS = [
  'https://assets.mixkit.co/videos/5218/5218-720.mp4',
  'https://assets.mixkit.co/videos/51649/51649-720.mp4',
  'https://assets.mixkit.co/videos/47476/47476-720.mp4',
];

/** Portrait (9:16) thumbnails for Gem Shorts carousel */
export const SAMPLE_SHORT_THUMBNAILS = [
  LOCAL_GEMS.pinkSpinel,
  LOCAL_GEMS.blueSapphire,
  LOCAL_GEMS.padparadscha,
  LOCAL_GEMS.redRuby,
  LOCAL_GEMS.greenEmerald,
  LOCAL_GEMS.yellowSapphire,
];

export const GEM_SHORTS_MOCK = [
  {
    id: 'short-1',
    thumbnail: SAMPLE_SHORT_THUMBNAILS[0],
    video: SAMPLE_VIDEOS[0],
    dealerName: 'Ratnapura Gems',
    title: '10x Zoom: Rare Pink Spinel Analysis',
  },
  {
    id: 'short-2',
    thumbnail: SAMPLE_SHORT_THUMBNAILS[1],
    video: SAMPLE_VIDEOS[1],
    dealerName: 'Ceylon Blue Co.',
    title: 'Unheated Royal Blue Sapphire Reveal',
  },
  {
    id: 'short-3',
    thumbnail: SAMPLE_SHORT_THUMBNAILS[2],
    video: SAMPLE_VIDEOS[0],
    dealerName: 'Beruwala Traders',
    title: 'Padparadscha Color Shift Under Light',
  },
  {
    id: 'short-4',
    thumbnail: SAMPLE_SHORT_THUMBNAILS[3],
    video: SAMPLE_VIDEOS[1],
    dealerName: 'Elahera Exports',
    title: 'Star Ruby Asterism Close-Up',
  },
  {
    id: 'short-5',
    thumbnail: SAMPLE_SHORT_THUMBNAILS[4],
    video: SAMPLE_VIDEOS[0],
    dealerName: 'Colombo Jewelers',
    title: 'Emerald Inclusion Mapping 101',
  },
];

export const SAMPLE_LOGO = '/assets/images/gembook-logo.svg';
export const DEFAULT_AVATAR = SAMPLE_AVATARS[0];
export const DEFAULT_GEM = SAMPLE_GEMS[0];
export const DEFAULT_DEALER_AVATAR = SAMPLE_AVATARS[4];

export const avatarAt = (index = 0) => SAMPLE_AVATARS[index % SAMPLE_AVATARS.length];
export const gemAt = (index = 0) => SAMPLE_GEMS[index % SAMPLE_GEMS.length];
export const coverAt = (index = 0) => SAMPLE_COVERS[index % SAMPLE_COVERS.length];
export const videoAt = (index = 0) => SAMPLE_VIDEOS[index % SAMPLE_VIDEOS.length];
export const shortThumbnailAt = (index = 0) => SAMPLE_SHORT_THUMBNAILS[index % SAMPLE_SHORT_THUMBNAILS.length];

/** Known dead Unsplash IDs → local gem replacements (legacy Firebase / mock data) */
const LEGACY_BROKEN_GEM_PATTERNS = [
  ['photo-1617038210897', LOCAL_GEMS.padparadscha],
  ['photo-1599643478518', LOCAL_GEMS.pinkSpinel],
  ['photo-1535632066927', LOCAL_GEMS.collection],
];

const normalizeAssetPath = (url) => {
  if (url.startsWith('/src/assets/images/')) {
    return url.replace('/src/assets/images/', '/assets/images/');
  }
  return url;
};

/** Returns url if valid, otherwise fallback sample image */
export const resolveImage = (url, fallback = DEFAULT_GEM) => {
  if (url && typeof url === 'string' && url.trim().length > 0) {
    return normalizeAssetPath(url.trim());
  }
  return fallback;
};

export const resolveAvatar = (url, index = 0) => resolveImage(url, avatarAt(index));
export const resolveGem = (url, index = 0) => {
  const resolved = resolveImage(url, gemAt(index));
  for (const [broken, replacement] of LEGACY_BROKEN_GEM_PATTERNS) {
    if (resolved.includes(broken)) return replacement;
  }
  return resolved;
};
export const resolveCover = (url, index = 0) => resolveImage(url, coverAt(index));

/** Ensures posts always have at least one media image */
export const resolvePostMedia = (media, index = 0) => {
  if (Array.isArray(media) && media.length > 0 && media.some((url) => url?.trim?.())) {
    return media.filter((url) => url?.trim?.());
  }
  return [gemAt(index)];
};
